// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3MfDy","colMaxWidth":"Table_colMaxWidth__22pGc"};